export default {
  contractFiles: [],
  contractFile: undefined,
};
